import { select, call, put } from "redux-saga/effects";
import { deconstructSchoolID } from "lib/appserver/aggregate";
import { sendSchoolMoneyDataRequest } from "state/fetchSagas";
import { getMobileNumber, getDeviceToken } from "state/app/selectors";
import { getCheckoutTransactionID, getCheckoutSchoolID, getCheckoutTotalToPay, getSecureTradingCardHolderName, getSecureTradingPSD2ErrorCode, getSecureTradingPSD2ErrorMessage, getParentEmailAddress } from "state/school_money/selectors";
import { secureTradingError, saveAudit } from "state/school_money/actions";
import { setCheckoutError, completeCheckout, getSecureTradingGetJwtStringComplete, processSecureTradingPaymentResponse, closeCheckout } from "state/school_money/actions";
import RemoteServerCompleteFailureError from "lib/appserver/responseExceptions/RemoteServerCompleteFailureError";

export function* secureTradingProcessPSD2Response(){

  const secureTradingErrorCode = yield select(getSecureTradingPSD2ErrorCode);
  const secureTradingErrorMessage = yield select(getSecureTradingPSD2ErrorMessage);
  yield put(saveAudit("ST_PAYMENT_RESPONSE"));

  if(secureTradingErrorCode === "0"){
    yield put(saveAudit("PAYMENT_SUCCESS"));
    yield put(completeCheckout());
  } else {
    yield put(saveAudit("PAYMENT_FAILED"));
    yield put(secureTradingError({ code : secureTradingErrorCode, description : secureTradingErrorMessage }));
  }

}

export function* secureTradingGetJWTString(){

  const transactionID   = yield select(getCheckoutTransactionID);
  const cardHolderName  = yield select(getSecureTradingCardHolderName);
  const schoolID        = yield select(getCheckoutSchoolID);
  const mobileNumber    = yield select(getMobileNumber);
  const deviceToken     = yield select(getDeviceToken);
  const amount          = yield select(getCheckoutTotalToPay);
  const cardHolderEmail = yield select(getParentEmailAddress, schoolID);
  const { serverID, remoteSchoolID } = deconstructSchoolID(schoolID);

  let dataRequestParameters = {};
  dataRequestParameters.server_id        = serverID;
  dataRequestParameters.remote_school_id = remoteSchoolID;
  dataRequestParameters.mobile_number    = mobileNumber;
  dataRequestParameters.device_token     = deviceToken;
  dataRequestParameters.amount           = amount;
  dataRequestParameters.cardholdername   = cardHolderName;
  dataRequestParameters.cardholderemail  = validateEmail(cardHolderEmail) ? cardHolderEmail : "";
  dataRequestParameters.cardholderphone  = mobileNumber;
  dataRequestParameters.transaction_id   = transactionID;

  try {

      // Invoke the get jwt api
      let response = yield call(sendSchoolMoneyDataRequest, "get_st_jwt", dataRequestParameters);

      // Process failures
      if(response.status === "error"){ yield put(secureTradingError({ code : response.code, description : response.message })); return; }

      // Invoke the get token completed action to update the state
      yield put(getSecureTradingGetJwtStringComplete(response.data.jwt));

  // Handle REMOTE_FAIL_COMPLETE.
  } catch (error) {
    if (error.type === RemoteServerCompleteFailureError.type) {
      yield put(setCheckoutError("ERROR_REMOTE_SERVER_FAIL"));
      return;
    } else {
      throw error;
    }
  }
}

function validateEmail(emailAddress) {
  if (emailAddress.search(/^\S+((-\S+)|(\.\S+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/) === -1 || emailAddress.indexOf("@") > 64) {
     return false;
 }
 return true;
}

export function* processGooglePayResponseSaga(paymentResponse) {

  try {
      yield put(saveAudit("Saga picked up google pay response: " + JSON.stringify(paymentResponse)));
    paymentResponse = paymentResponse.payload.response;
    const decryptedJWT = JSON.parse(atob(paymentResponse.jwt.split('.')[1]));

    if(paymentResponse.paymentResponse === "cancelled") {
      yield put(closeCheckout());
    } else if (paymentResponse.jwt === undefined || decryptedJWT.payload.response[0].errorcode !== "0") {
        yield put(saveAudit("Saga processing failed payment"));

      yield put(
        processSecureTradingPaymentResponse(
          {
            errorcode: "INVALID_RESPONSE",
            errormessage: "Invalid payment response",
            jwt: ""
          }
        )
      );
    } else {
        yield put(saveAudit("Saga processing successful payment"));
      yield put(
        processSecureTradingPaymentResponse(
          {
            errorcode: "0",
            errormessage: "",
            jwt: paymentResponse.jwt
          }
        )
      );
    }
  } catch (error) {
    yield put(
      processSecureTradingPaymentResponse(
        {
          errorcode: "GOOGLE_PAY_INVALID_CARD_DETAILS",
          errormessage: "Invalid card details",
          jwt: ""
        }
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/secureTradingSaga.js